const dependenciesEP = {
    status: {
        "Pending Documentation": [
            "managedBy",
            "initialNotes",
            "protocol",
            "area",
            "recipientInvestigator",
            "experimentType",
            "assayType",
            "assayDetails",
            "mechPurpose",
            "chairApproval",
            "approvedSOP",
            "requestedCriteria",
            "blindingRequired",
        ],
        "Pending Approval": [
            "scopeOfWorkRequired",
            "materialTransferAgreementRequired",
            "dataTransferAgreementRequired",
            "approvalMessageRequired",
            "managedBy",
            "initialNotes",
            "protocol",
            "area",
            "recipientInvestigator",
            "labs",
            "experimentType",
            "assayType",
            "assayDetails",
            "mechPurpose",
            "itnFunded",
            "chairApproval",
            "approvedSOP",
            "requestedCriteria",
            "blindingRequired",
        ],
        "Real Time": [
            "scopeOfWorkRequired",
            "materialTransferAgreementRequired",
            "dataTransferAgreementRequired",
            "managedBy",
            "priority",
            "protocol",
            "area",
            "recipientInvestigator",
            "labs",
            "experimentType",
            "assayType",
            "itnFunded",
            "chairApproval",
            "blindingRequired",
            "dispositionOfSample",
        ],
        "Withdrawn": [
            "statusComment"
        ],
        "Completed": [
            "statusComment"
        ]
    },
    approvalMessageRequired: {
        "No": [
            "approvalMessageComment"
        ]
    },
    experimentType: {
        "Future Studies": [
            "genetic"
        ]
    },
    chairApproval: {
        "No": [
            "chairApprovalComment"
        ]
    },
    approvedSOP: {
        "No": [
            "approvedSOPComment"
        ],
        "Requested": [
            "approvedSOPComment"
        ]
    },
    blindingRequired: {
        "Yes": [
            "blindingComment",
            "relabelingRequired",
        ]
    },
    relabelingRequired: {
        "Yes": [
            "relabelingDetails"
        ]
    },
};

const dependenciesSD = {
    status: {
        "Pending Documentation": [
            "certificateOfDestructionRequired",
            "managedBy",
            "initialNotes",
            "protocol",
            "area",
            "chairApproval",
            "requestedCriteria",
        ],
        "Pending Approval": [
            "certificateOfDestructionRequired",
            "managedBy",
            "initialNotes",
            "protocol",
            "area",
            "chairApproval",
            "requestedCriteria",
        ],
        "Real Time": [
            "certificateOfDestructionRequired",
            "managedBy",
            "initialNotes",
            "protocol",
            "area",
            "chairApproval",
            "requestedCriteria",
        ],
        "Withdrawn": [
            "statusComment"
        ],
        "Completed": [
            "statusComment"
        ]
    },
    chairApproval: {
        "No": [
            "chairApprovalComment"
        ]
    },
};

const dependenciesWF = {
    informedConsent: {
        "Non-ITN": [
            "informedConsentComment"
        ]
    },
    informedConsentApprover: {
        "Non-ITN": [
            "informedConsentComment"
        ]
    },
    disposalReason: {
        "Other (specify below)": [
            "pullListComment"
        ]
    }
};

export const getRequiredEPFields = (field, data) => {
    const fieldDependencies = dependenciesEP[field];
    const required = new Set();

    if (fieldDependencies && fieldDependencies[data[field]]) {
        fieldDependencies[data[field]].forEach(subField => {
            required.add(subField);
        });
    }

    return Array.from(required);
}

export const getRequiredSDFields = (field, data) => {
    const fieldDependencies = dependenciesSD[field];
    const required = new Set();

    if (fieldDependencies && fieldDependencies[data[field]]) {
        fieldDependencies[data[field]].forEach(subField => {
            required.add(subField);
        });
    }

    return Array.from(required);
}

export const getRequiredWFFields = (field, data) => {
    const fieldDependencies = dependenciesWF[field];
    const required = new Set();

    if (fieldDependencies && fieldDependencies[data[field]]) {
        fieldDependencies[data[field]].forEach(subField => {
            required.add(subField);
        });
    }

    return Array.from(required);
}
